import script from "./ContentImage.vue?vue&type=script&setup=true&lang=ts"
export * from "./ContentImage.vue?vue&type=script&setup=true&lang=ts"

import "./ContentImage.vue?vue&type=style&index=0&id=01a2a57a&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01a2a57a"]])

export default __exports__